module.exports = __webpack_public_path__ + "img/logo.fd95c410.png";